import { render, staticRenderFns } from "./ResponsivePanelsLayout.vue?vue&type=template&id=e1f77f20&scoped=true&"
import script from "./ResponsivePanelsLayout.vue?vue&type=script&lang=js&"
export * from "./ResponsivePanelsLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePanelsLayout.vue?vue&type=style&index=0&id=e1f77f20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f77f20",
  null
  
)

export default component.exports